import { render, staticRenderFns } from "./NotificationManagement.vue?vue&type=template&id=190ff568&scoped=true&"
import script from "./NotificationManagement.vue?vue&type=script&lang=js&"
export * from "./NotificationManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190ff568",
  null
  
)

export default component.exports